import { render, staticRenderFns } from "./AddEditLexicon.vue?vue&type=template&id=03b964e0&scoped=true"
import script from "./AddEditLexicon.vue?vue&type=script&lang=js"
export * from "./AddEditLexicon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b964e0",
  null
  
)

export default component.exports